<template>
    <client-page>
        <!-- S: 서브 비주얼 -->
        <template #subHead>
            <sub-visual id="rmfarm" title="Solution" src="/images/sub/subvisual-solution.jpg"></sub-visual>
        </template>
        <!-- E: 서브 비주얼 -->

        <page-section class="page-section--first">
            <template #titleLine>
                Smart Farm Solution
            </template>
            <tit-wrap-large>
                <b>Medium Water Content Measurement Device</b>
                <template #text>The product enhances the quality and yield of crops by providing data on the water content in root zones.</template>
            </tit-wrap-large>

            <v-img max-width="794" :aspect-ratio="794 / 378" src="/images/sub/solution/smartfarm/rmfarm-img.png" class="mx-auto" data-aos="fade" data-aos-delay="100" />
        </page-section>

        <v-container>
            <v-divider class="grey lighten-3" />
        </v-container>

        <page-section>
            <page-section class="page-section--sm py-0">
                <template #pageSectionImmersive>
                    <tit-wrap-large class="tit-wrap--lg">
                        <b>RMFarm recognized for <br class="d-none d-lg-block" />its innovativeness and technology</b>
                        <template #text>RMFarm recognized for its innovativeness and technology RMFarm is <br class="d-none d-md-block" />an excellent and innovative R&D product registered in the Innovation Market of the Public Procurement Service. </template>
                    </tit-wrap-large>

                    <v-row class="row--lg">
                        <v-col cols="12" md="6" lg="4" data-aos="fade-left" data-aos-delay="100">
                            <v-card rounded="" color="grey lighten-5">
                                <v-responsive :aspect-ratio="374 / 298" content-class="d-flex pa-20px">
                                    <v-img max-width="270" :aspect-ratio="270 / 68" src="/images/sub/solution/smartfarm/rmfarm-img2.png" class="ma-auto" />
                                </v-responsive>
                            </v-card>
                            <div class="mt-20px mt-md-40px">
                                <tit-wrap-sprout>
                                    RMFarm Premium
                                </tit-wrap-sprout>

                                <txt-item titleClass="w-md-140px">
                                    <template #title>Measurement items</template>
                                    Real-time weight, supply amount, drainage amount, drainage EC, drainage pH, medium temperature, temperature, and humidity
                                </txt-item>

                                <txt-item titleClass="w-md-140px">
                                    <template #title>Applications</template>
                                    Greenhouse crops such as bell peppers, tomatoes, and strawberries
                                </txt-item>
                            </div>
                        </v-col>
                        <v-col cols="12" md="6" lg="4" data-aos="fade-left" data-aos-delay="200">
                            <v-card rounded="" color="grey lighten-5">
                                <v-responsive :aspect-ratio="374 / 298" content-class="d-flex pa-20px">
                                    <v-img max-width="304" :aspect-ratio="304 / 90" src="/images/sub/solution/smartfarm/rmfarm-img3.png" class="ma-auto" />
                                </v-responsive>
                            </v-card>
                            <div class="mt-20px mt-md-40px">
                                <tit-wrap-sprout>
                                    RMFarm Basic
                                </tit-wrap-sprout>

                                <txt-item titleClass="w-md-140px">
                                    <template #title>Measurement items</template>
                                    Real-time weight, supply amount, drainage amount, drainage EC, and drainage pH
                                </txt-item>

                                <txt-item titleClass="w-md-140px">
                                    <template #title>Applications</template>
                                    Greenhouse crops such as bell peppers and tomatoes
                                </txt-item>
                            </div>
                        </v-col>
                        <v-col cols="12" md="6" lg="4" data-aos="fade-left" data-aos-delay="300">
                            <v-card rounded="" color="grey lighten-5">
                                <v-responsive :aspect-ratio="374 / 298" content-class="d-flex pa-20px">
                                    <v-img max-width="260" :aspect-ratio="260 / 132" src="/images/sub/solution/smartfarm/rmfarm-img4.png" class="ma-auto" />
                                </v-responsive>
                            </v-card>
                            <div class="mt-20px mt-md-40px">
                                <tit-wrap-sprout>
                                    RMFarm Entry-level
                                </tit-wrap-sprout>

                                <txt-item titleClass="w-md-140px">
                                    <template #title>Measurement items</template>
                                    Real-time weight, supply amount, and drainage amount
                                </txt-item>

                                <txt-item titleClass="w-md-140px">
                                    <template #title>Applications</template>
                                    Medium-based greenhouse crops such as bell peppers and tomatoes
                                </txt-item>
                            </div>
                        </v-col>
                    </v-row>
                </template>
            </page-section>

            <page-section class="page-section--sm pb-0">
                <template #pageSectionImmersive>
                    <v-card rounded="" color="grey lighten-5" data-aos="fade" data-aos-delay="100">
                        <v-responsive :aspect-ratio="1200 / 770" content-class="d-flex align-center justify-center">
                            <div class="pa-30px pa-md-40px px-lg-80px">
                                <v-img max-width="800" :width="$vuetify.breakpoint.lgAndUp ? '800' : ''" :aspect-ratio="800 / 376" src="/images/sub/solution/smartfarm/rmfarm-img5.png" class="mx-auto" />
                                <div class="pt-30px pt-md-40px pt-lg-60px">
                                    <tit-wrap-small>
                                        Easy and simple real-time monitoring via both the Internet and mobile device
                                        <template #text>Our self-developed software provides a simple and easy user-friendly interface. <br class="d-none d-lg-block" />You can access information via the PC, tablet, and mobile device.</template>
                                    </tit-wrap-small>
                                </div>
                            </div>
                        </v-responsive>
                    </v-card>
                </template>
            </page-section>

            <page-section class="page-section--sm pb-0">
                <template #pageSectionImmersive>
                    <v-row justify="center">
                        <v-col cols="12" md="6" lg="4" data-aos="fade" data-aos-delay="100">
                            <v-card outlined rounded="">
                                <v-img max-width="382" :aspect-ratio="382 / 540" src="/images/sub/solution/smartfarm/rmfarm-img6.jpg" class="ma-auto" />
                            </v-card>
                            <tit-wrap-small mbSmall class="mt-14px mt-md-20px">
                                Registered Patent
                                <template #text>
                                    Moisture Content Measurement Apparatus of Plants' Root Zone
                                </template>
                            </tit-wrap-small>
                        </v-col>
                        <v-col cols="12" md="6" lg="4" data-aos="fade" data-aos-delay="200">
                            <v-card outlined rounded="">
                                <v-img max-width="382" :aspect-ratio="382 / 540" src="/images/sub/solution/smartfarm/rmfarm-img7.jpg" class="ma-auto" />
                            </v-card>
                            <tit-wrap-small mbSmall class="mt-14px mt-md-20px">
                                Registered in the Agricultural Machinery List
                                <template #text>
                                    Root zone water content measurement device
                                </template>
                            </tit-wrap-small>
                        </v-col>
                        <v-col cols="12" md="6" lg="4" data-aos="fade" data-aos-delay="300">
                            <v-card outlined rounded="">
                                <v-img max-width="382" :aspect-ratio="382 / 540" src="/images/sub/solution/smartfarm/rmfarm-img8.jpg" class="ma-auto" />
                            </v-card>
                            <tit-wrap-small mbSmall class="mt-14px mt-md-20px">
                                Registered as an innovative product
                                <template #text>
                                    Registered in the Innovation Market of the Public Procurement Service
                                </template>
                            </tit-wrap-small>
                        </v-col>
                    </v-row>
                </template>
            </page-section>
        </page-section>

        <v-container>
            <v-divider class="grey lighten-3" />
        </v-container>

        <page-section id="rmfarm-portfolio" class="page-section--last">
            <template #title>
                Portfolio
            </template>

            <div class="tabs-wrap">
                <v-tabs v-model="tab" hide-slider show-arrows centered center-active class="v-tabs--btn">
                    <u-tab to="#rmfarm-high-tab" id="rmfarm-high-tab">RMFarm Premium</u-tab>
                    <u-tab to="#rmfarm-basic-tab" id="rmfarm-basic-tab">RMFarm Basic</u-tab>
                    <u-tab to="#rmfarm-entry-tab" id="rmfarm-entry-tab">RMFarm Entry-level</u-tab>
                </v-tabs>
            </div>

            <template #pageSectionImmersive>
                <div style="max-width:1480px" class="mx-auto px-12px">
                    <v-tabs-items v-model="tab" touchless>
                        <v-tab-item value="rmfarm-high-tab" transition="fade-transition" reverse-transition="fade-transition">
                            <rmfarm-high-slide />
                        </v-tab-item>
                        <v-tab-item value="rmfarm-basic-tab" transition="fade-transition" reverse-transition="fade-transition">
                            <rmfarm-basic-slide />
                        </v-tab-item>
                        <v-tab-item value="rmfarm-entry-tab" transition="fade-transition" reverse-transition="fade-transition">
                            <rmfarm-entry-slide />
                        </v-tab-item>
                    </v-tabs-items>
                </div>
            </template>
        </page-section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import PageSection from "@/pages/client/templates/page-section.vue";
import TitWrapSmall from "@/components/dumb/tit-wrap-small.vue";
import TitWrapLarge from "@/components/dumb/tit-wrap-large.vue";
import TitWrapSprout from "@/components/dumb/tit-wrap-sprout.vue";
import TxtItem from "@/components/dumb/txt-item.vue";
import UTabs from "@/components/dumb/u-tabs.vue";
import UTab from "@/components/dumb/u-tab.vue";
import RmfarmHighSlide from "@/pages/client/sub/solution/RmfarmHighSlide.vue";
import RmfarmBasicSlide from "@/pages/client/sub/solution/RmfarmBasicSlide.vue";
import RmfarmEntrySlide from "@/pages/client/sub/solution/RmfarmEntrySlide.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        PageSection,
        TitWrapSmall,
        TitWrapLarge,
        TitWrapSprout,
        TxtItem,
        UTabs,
        UTab,
        RmfarmHighSlide,
        RmfarmBasicSlide,
        RmfarmEntrySlide,
    },
    props: {},
    data() {
        return {
            tab: null,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {});
        },
    },
};
</script>

<style lang="scss" scoped></style>
